import React from "react";
import CustomNav from "../Components/NavBar";
import { Container, Button, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faBriefcase } from "@fortawesome/free-solid-svg-icons";
import { faGithubSquare, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import useWindowDimensions from "../utils/dimensionHelper";

const HERO_TECH = ["React", "Next.js", "TypeScript", "Node.js", "GraphQL", "REST API", "Tailwind", "Redux"];

const Home = () => {
  const { width } = useWindowDimensions();
  const isNarrow = width <= 760;

  return (
    <>
      <CustomNav />
      <div className="home-hero">
        <div className="home-hero__bg" aria-hidden="true" />
        <Container className="home-hero__container h-100">
          <div className="d-flex flex-column flex-md-row h-100 align-items-center justify-content-center">
            <div className={`home-hero__content my-auto ${isNarrow ? "text-center" : ""}`}>
              <p className="home-hero__greeting color-customBlueLight">
                Hello, I'm
              </p>
              <h1 className="home-hero__name color-customBlue">
                Shahnawaz Malek
              </h1>
              <p className="home-hero__role color-customBlueLight">
                Software Engineer · 4+ years building web applications
              </p>
              <p className="home-hero__summary color-customBlueLight">
                I architect and ship responsive, performant UIs with{" "}
                <strong className="color-customBlue">React</strong>,{" "}
                <strong className="color-customBlue">Next.js</strong>, and{" "}
                <strong className="color-customBlue">TypeScript</strong>—from
                enterprise admin portals to high-traffic news and SSO platforms.
              </p>

              <div className="home-hero__meta">
                <span className="home-hero__meta-item">
                  <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2" />
                  Ahmedabad, India
                </span>
                <span className="home-hero__meta-item">
                  <FontAwesomeIcon icon={faBriefcase} className="mr-2" />
                  Solute Technolabs
                </span>
              </div>

              <div className="home-hero__tech">
                {HERO_TECH.map((tech) => (
                  <span key={tech} className="home-hero__tech-pill">
                    {tech}
                  </span>
                ))}
              </div>

              <div className={`home-hero__actions mt-4`}>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/Malek1117"
                  className="home-hero__social color-customBlue"
                  aria-label="GitHub"
                >
                  <FontAwesomeIcon size="2x" icon={faGithubSquare} />
                </a>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://www.linkedin.com/in/shahnawaz-malek-334789130"
                  className="home-hero__social color-customBlue ml-3"
                  aria-label="LinkedIn"
                >
                  <FontAwesomeIcon size="2x" icon={faLinkedin} />
                </a>
                <Button
                  className="home-hero__resume-btn bg-customBlue font-weight-bold shadow border-0 ml-3"
                  onClick={() => window.open("/shahnawaz-malek.pdf", "_blank")}
                >
                  Download Resume
                </Button>
              </div>
            </div>
            <div className="home-hero__visual d-none d-md-flex align-items-center justify-content-center">
              <Image
                src="images/pp.svg"
                roundedCircle
                fluid
                className="profilePic home-hero__profile"
                alt="Shahnawaz Malek"
              />
            </div>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Home;
